export const PERMISSIONS = {
  // Dashboard
  DASHBOARD_VIEW: "dashboard_view",
  DASHBOARD_SALES_REPORT_VIEW: "dashboard_sales_report_view",
  DASHBOARD_PLANNING_BOARD_VIEW: "dashboard_planning_board_view",

  // Customers
  CUSTOMER_LIST_VIEW: "customer_list_view",
  CUSTOMER_CREATE: "customer_create",
  CUSTOMER_EDIT: "customer_edit",
  CUSTOMER_EXPORT: "customer_export",

  // Jobs
  JOB_LIST_VIEW: "job_list_view",
  JOB_CUSTOMER_NAME_VIEW: "job_customer_name_view",
  JOB_ASSIGN_CUSTOMER: "job_assign_customer",
  JOB_CREATE: "job_create",
  JOB_EDIT: "job_edit",
  JOB_ADD_FILE: "job_add_file",
  JOB_DELETE_FILE: "job_delete_file",
  JOB_VALUE_VIEW: "job_value_view",
  JOB_STATUS_UPDATE: "job_status_update",
  JOB_ARCHIVE_UNARCHIVE: "job_archive_unarchive",
  JOB_SET_IN_OUT_DATE: "job_set_in_out_date",
  JOB_CARD_COLOR_UPDATE: "job_card_color_update",
  JOB_CARD_DOT_UPDATE: "job_card_dot_update",
  JOB_NOTE_CREATE: "job_note_create",
  JOB_NOTE_VIEW: "job_note_view",
  JOB_NOTE_CREATE_AND_SEND: "job_note_create_and_send",
  JOB_ARCHIVE_VIEW: "job_archive_view",
  JOB_EXPORT: "job_export",

  // Planning
  PLANNING_BOARD_VIEW: "planning_board_view",

  // Production
  PRODUCTION_BOARD_VIEW: "production_board_view",

  // Settings
  SETTINGS_VIEW: "settings_view",
  SETTINGS_EDIT: "settings_edit",
  SETTINGS_USER_CREATE: "settings_user_create",
  SETTINGS_USER_EDIT: "settings_user_edit",
  SETTINGS_USER_STATUS_UPDATE: "settings_user_status_update",
  SETTINGS_SEND_RESET_PASSWORD: "settings_send_reset_password",
  SETTINGS_CUSTOMIZE_STATUS_COLUMN: "settings_customize_status_column",

  // Connections
  CONNECTION_VIEW: "connection_view",
  CONNECTION_CONNECT_DISCONNECT: "connection_connect_disconnect",

  // Billing
  BILLING_VIEW: "billing_view",
};
